module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"newPolicy.title":"Create Policy","editPolicy.title":"Edit Policy"}}')
  delete Component.options._Ctor
}
